import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const rolesCrumb = {
  label: 'global.sidebar.roles_trans',
  route: { name: 's-roles' },
};

const roles_routes = [
  {
    path: 'roles',
    name: 'roles',
    meta: {
      permissions: 'read-roles-&-permissions',
    },
    children: [
      {
        path: '',
        name: 's-roles',
        component: () => import('@/views/System/Settings/Roles/RolesList.vue'),
        meta: {
          permissions: 'read-roles-&-permissions',
          breadcrumbs: settingsBreadcrumbs(rolesCrumb),
        },
      },
      {
        path: 'add',
        name: 's-roles-add',
        component: () => import('@/views/System/Settings/Roles/Components/RoleForm.vue'),
        meta: {
          permissions: 'write-roles-&-permissions',
          breadcrumbs: settingsBreadcrumbs(rolesCrumb),
        },
      },
      {
        path: 'edit/:id',
        name: 's-roles-edit',
        component: () => import('@/views/System/Settings/Roles/Components/RoleForm.vue'),
        meta: {
          permissions: 'update-roles-&-permissions',
          breadcrumbs: settingsBreadcrumbs(rolesCrumb),
        },
      },
    ],
  },
];

export default roles_routes;
